<div
    fxLayout="column"
    *ngIf="item?.layout === 'square'"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
>
    <div
        *ngIf="!!item?.image"
        fxLayout="column"
        style="background-color: #f7f7f7; cursor: pointer"
    >
        <div
            fxLayout
            fxLayoutAlign="center"
            style="padding: 0 0 0; position: relative; width: 100%"
        >
            <div
                fxFlex="nogrow"
                fxLayout
                fxLayoutAlign="space-between"
                class="content-overlay-box"
                [ngStyle]="{ position: 'absolute', width: '100%' }"
            >
                <img
                    *ngIf="item?.overlay?.image"
                    (click)="process(item?.link)"
                    class="overlayImg"
                    [ngStyle.gt-xs]="{ marginLeft: '16px', marginTop: '16px' }"
                    [ngStyle.xs]="{ marginLeft: '8px', marginTop: '8px' }"
                    src="{{ item?.overlay?.image }}"
                />
                <p
                    fxLayoutAlign="start center"
                    class="new"
                    ngClass.xs="new__mobile"
                    [ngStyle]="{
                        color: item?.overlay?.title?.color,
                        backgroundColor: item?.overlay?.background,
                        zIndex: 1
                    }"
                >
                    {{ item.overlay?.title?.text }}
                </p>
                <button
                    *ngIf="item?.button?.icon"
                    mat-icon-button
                    fxLayoutAlign="center center"
                    style="z-index: 3"
                    (mouseenter)="
                        item?.hoverEnabled
                            ? setHoverImage($event, 'wishlist')
                            : ''
                    "
                    (mouseleave)="
                        item?.hoverEnabled
                            ? setInitialImage($event, 'wishlist')
                            : ''
                    "
                    ngClass.gt-xs="wishlist-desktop-button"
                    (click)="process(item?.button.link)"
                >
                    <img
                        class="icon"
                        src="{{ item?.button?.icon }}"
                        ngClass.xs="icon__mobile"
                        appImageCDN
                    />
                </button>
            </div>
            <img
                *ngIf="item?.overlayIcon"
                src="{{ item?.overlayIcon }}"
                class="overlay-icon"
                ngClass.xs="overlay-icon__mobile"
                appImageCDN
            />
            <picture
                style="width: 100%; padding-top: calc({{
                    measurement
                }} * 100%);"
                class="content-image"
                (mouseenter)="setHoverImage($event, 'content')"
                (mouseleave)="setInitialImage($event, 'content')"
            >
                <a
                    class="anchor-tag"
                    [routerLink]="[item.link | pageIdFromLink]"
                    [queryParams]="item.link | queryParamFromLink"
                >
                    <img
                        class="image"
                        src="{{ currentVisibleImage }}"
                        appImageCDN
                    />
                </a>
            </picture>
        </div>
    </div>
    <div
        fxLayout="column"
        style="margin-top: 8px"
        [ngStyle]="{ height: item.cta ? '100px' : 'none' }"
        [ngClass.xs]="{ mar8: !item.cta }"
    >
        <a
            *ngIf="botAgent"
            style="text-decoration: none; color: black"
            [routerLink]="[item.link | pageIdFromLink]"
            [queryParams]="item.link | queryParamFromLink"
        >
            <div class="mrp" fxLayout>
                <p *ngIf="item?.price?.text" class="price" style="margin: 0">{{
                    item.price?.text
                }}</p>
                <p class="colortype" style="margin: 0"></p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 12px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p
                *ngIf="item?.title?.text"
                class="text"
                style="color:{{ item?.title?.color }}"
            >
                {{ item.title?.text }}
            </p>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </a>
        <ng-container *ngIf="!botAgent">
            <p class="text" style="color:{{ item?.title?.color }}">
                {{ item.title?.text }}
            </p>
            <div class="mrp" fxLayout>
                <p class="price" style="margin: 0">{{ item.price?.text }}</p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <div
                *ngIf="item?.memberPrice"
                fxLayout
                style="margin-bottom: 8px"
                ngClass.xs="membership-offer"
                fxLayoutAlign.xs="start center"
            >
                <p
                    class="membership-price"
                    [ngStyle]="{
                        color: item?.memberPrice?.prefix?.color,
                        backgroundColor: item?.memberPrice?.background?.color
                    }"
                >
                    {{ item?.memberPrice?.prefix?.text }}
                    <span class="member-body">
                        <img
                            class="membership-image"
                            appImageCDN
                            src="{{ item.memberPrice?.icon }}"
                        />

                        <p
                            *ngIf="item?.memberPrice?.suffix?.text"
                            class="membership-name"
                            [ngStyle]="{
                                color: item?.memberPrice?.suffix?.color
                            }"
                        >
                            {{ item?.memberPrice?.suffix?.text }}</p
                        >
                    </span>
                </p>
            </div>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </ng-container>
    </div>
    <button
        *ngIf="item.cta"
        color="primary"
        class="addToCartBtn"
        style="height: 36px"
        mat-raised-button
        (click)="process(item?.cta?.link)"
    >
        {{ item.cta?.text }}
    </button>
</div>
<div
    *ngIf="item?.layout === 'listing-banner'"
    fxLayout="column"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
>
    <div>
        <picture class="listing-banner">
            <img
                class="listing-banner-img"
                [ngStyle]="{ cursor: item?.banner?.link ? 'pointer' : 'none' }"
                (click)="process(item?.banner?.link)"
                src="{{ item?.banner?.image }}"
                appImageCDN
            />
        </picture>
    </div>
</div>
<div
    *ngIf="item?.layout === 'square-banner'"
    fxLayout="column"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
>
    <div>
        <picture class="listing-banner">
            <img
                class="listing-banner-img"
                src="{{ item?.banner?.image }}"
                appImageCDN
            />
        </picture>
    </div>
</div>
<div
    fxLayout="column"
    *ngIf="item?.layout === 'product-with-variant-details'"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
    [ngStyle.xs]="{ marginBottom: '10px' }"
>
    <div
        *ngIf="!!item?.image"
        fxLayout="column"
        style="background-color: #f7f7f7; cursor: pointer"
    >
        <div
            fxLayout
            fxLayoutAlign="center"
            style="padding: 0 0 0; position: relative; width: 100%"
        >
            <div
                fxFlex="nogrow"
                fxLayout
                fxLayoutAlign="space-between"
                class="content-overlay-box"
                [ngStyle]="{ position: 'absolute', width: '100%' }"
            >
                <img
                    *ngIf="item?.overlay?.image"
                    (click)="process(item?.link)"
                    class="overlayImg"
                    [ngStyle.gt-xs]="{ marginLeft: '16px', marginTop: '16px' }"
                    [ngStyle.xs]="{ marginLeft: '8px', marginTop: '8px' }"
                    src="{{ item?.overlay?.image }}"
                />
                <p
                    fxLayoutAlign="start center"
                    class="new"
                    ngClass.xs="new__mobile"
                    [ngStyle]="{
                        color: item?.overlay?.title?.color,
                        backgroundColor: item?.overlay?.background,
                        zIndex: 1
                    }"
                >
                    {{ item.overlay?.title?.text }}
                </p>
                <button
                    *ngIf="item?.button?.icon"
                    mat-icon-button
                    fxLayoutAlign="center center"
                    style="z-index: 3"
                    (mouseenter)="
                        item?.hoverEnabled
                            ? setHoverImage($event, 'wishlist')
                            : ''
                    "
                    (mouseleave)="
                        item?.hoverEnabled
                            ? setInitialImage($event, 'wishlist')
                            : ''
                    "
                    ngClass.gt-xs="wishlist-desktop-button"
                    (click)="process(item?.button.link)"
                >
                    <img
                        class="icon"
                        src="{{ item?.button?.icon }}"
                        ngClass.xs="icon__mobile"
                        appImageCDN
                    />
                </button>
            </div>

            <picture
                style="width: 100%; padding-top: calc({{
                    measurement
                }} * 100%);"
                class="content-image"
                (mouseenter)="setHoverImage($event, 'content')"
                (mouseleave)="setInitialImage($event, 'content')"
            >
                <a
                    class="anchor-tag"
                    [routerLink]="[item.link | pageIdFromLink]"
                    [queryParams]="item.link | queryParamFromLink"
                >
                    <img
                        class="image"
                        src="{{ currentVisibleImage }}"
                        appImageCDN
                    />
                </a>
            </picture>
        </div>
    </div>
    <div
        fxLayout="column"
        style="margin-top: 12px"
        [ngStyle]="{ height: item.cta ? '96px' : 'none' }"
        [ngClass.xs]="{ mar8: !item.cta }"
    >
        <a
            *ngIf="botAgent"
            style="text-decoration: none; color: black"
            [routerLink]="[item.link | pageIdFromLink]"
            [queryParams]="item.link | queryParamFromLink"
        >
            <div class="mrp" fxLayout>
                <p *ngIf="item?.price?.text" class="price" style="margin: 0">{{
                    item.price?.text
                }}</p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p *ngIf="item?.title?.text" class="text">
                {{ item.title?.text }}
            </p>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </a>
        <ng-container *ngIf="!botAgent">
            <p class="variant-text" [ngStyle.xs]="{ fontSize: '13px' }">
                {{ item.title?.text }}
            </p>
            <p class="colortype" [ngStyle.xs]="{ fontSize: '12px' }">
                {{ item?.variantDetail }}
            </p>
            <div class="mrp" fxLayout>
                <p
                    class="price"
                    style="margin: 0"
                    [ngStyle.xs]="{ fontSize: '13px' }"
                    >{{ item.price?.text }}</p
                >
                <p
                    [ngStyle.xs]="{
                        fontSize: '13px',
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p
                *ngIf="item?.subtitle?.text"
                [ngStyle.xs]="{ fontSize: '13px' }"
                class="variant-offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </ng-container>
    </div>
    <button
        *ngIf="item.cta"
        color="primary"
        class="call-to-action-button"
        style="height: 36px"
        mat-raised-button
        (click)="process(item?.cta?.link)"
    >
        {{ item.cta?.text }}
    </button>
</div>
<div
    fxLayout="column"
    *ngIf="item?.layout === 'product-without-variant-details'"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
    [ngStyle.xs]="{ marginBottom: '10px' }"
>
    <div
        *ngIf="!!item?.image"
        fxLayout="column"
        style="background-color: #f7f7f7; cursor: pointer"
    >
        <div
            fxLayout
            fxLayoutAlign="center"
            style="padding: 0 0 0; position: relative; width: 100%"
        >
            <div
                fxFlex="nogrow"
                fxLayout
                fxLayoutAlign="space-between"
                class="content-overlay-box"
                [ngStyle]="{ position: 'absolute', width: '100%' }"
            >
                <img
                    *ngIf="item?.overlay?.image"
                    (click)="process(item?.link)"
                    class="overlayImg"
                    [ngStyle.gt-xs]="{ marginLeft: '16px', marginTop: '16px' }"
                    [ngStyle.xs]="{ marginLeft: '8px', marginTop: '8px' }"
                    src="{{ item?.overlay?.image }}"
                />
                <p
                    fxLayoutAlign="start center"
                    class="new"
                    ngClass.xs="new__mobile"
                    [ngStyle]="{
                        color: item?.overlay?.title?.color,
                        backgroundColor: item?.overlay?.background,
                        zIndex: 1
                    }"
                >
                    {{ item.overlay?.title?.text }}
                </p>
                <button
                    *ngIf="item?.button?.icon"
                    mat-icon-button
                    fxLayoutAlign="center center"
                    style="z-index: 3"
                    (mouseenter)="
                        item?.hoverEnabled
                            ? setHoverImage($event, 'wishlist')
                            : ''
                    "
                    (mouseleave)="
                        item?.hoverEnabled
                            ? setInitialImage($event, 'wishlist')
                            : ''
                    "
                    ngClass.gt-xs="wishlist-desktop-button"
                    (click)="process(item?.button.link)"
                >
                    <img
                        class="icon"
                        src="{{ item?.button?.icon }}"
                        ngClass.xs="icon__mobile"
                        appImageCDN
                    />
                </button>
            </div>
            <picture
                style="width: 100%; padding-top: calc({{
                    measurement
                }} * 100%);"
                [ngStyle]="{ backgroundColor: item?.productBgColor }"
                class="content-image"
                (mouseenter)="setHoverImage($event, 'content')"
                (mouseleave)="setInitialImage($event, 'content')"
            >
                <a
                    class="anchor-tag"
                    [routerLink]="[item.link | pageIdFromLink]"
                    [queryParams]="item.link | queryParamFromLink"
                >
                    <img
                        class="image"
                        style="background-color: white"
                        src="{{ currentVisibleImage }}"
                        appImageCDN
                    />
                </a>
            </picture>
        </div>
    </div>
    <div
        fxLayout="column"
        style="margin-top: 0px; margin-left: 26px"
        ngStyle.xs="margin-left: 10px"
        [ngStyle]="{ height: item.cta ? '96px' : 'none' }"
        [ngClass.xs]="{ mar8: !item.cta }"
    >
        <a
            *ngIf="botAgent"
            style="text-decoration: none; color: black"
            [routerLink]="[item.link | pageIdFromLink]"
            [queryParams]="item.link | queryParamFromLink"
        >
            <div class="mrp" fxLayout>
                <p *ngIf="item?.price?.text" class="price" style="margin: 0">{{
                    item.price?.text
                }}</p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p *ngIf="item?.title?.text" class="text">
                {{ item.title?.text }}
            </p>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </a>
        <ng-container *ngIf="!botAgent">
            <p
                class="variant-text-v2"
                ngClass.xs="variant-text-v2__mobile"
                ngStyle.xs="{ fontSize: '14px!important' }"
            >
                {{ item.title?.text }}
            </p>
            <div class="mrp-v2" fxLayout>
                <p
                    class="price_v2"
                    style="margin: 0"
                    [ngStyle.xs]="{ fontSize: '13px' }"
                    >{{ item.price?.text }}</p
                >
                <p
                    [ngStyle.xs]="{
                        fontSize: '13px',
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p
                *ngIf="item?.subtitle?.text"
                [ngStyle.xs]="{ fontSize: '13px' }"
                class="variant-offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </ng-container>
    </div>
    <button
        *ngIf="item.cta"
        color="primary"
        class="call-to-action-button"
        style="height: 36px"
        mat-raised-button
        (click)="process(item?.cta?.link)"
    >
        {{ item.cta?.text }}
    </button>
</div>
<div
    fxLayout="column"
    style="height: 100%"
    *ngIf="item?.layout === 'product-without-variant-details-v2'"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
>
    <div
        *ngIf="!!item?.image"
        fxLayout="column"
        [ngStyle]="{ backgroundColor: item?.productBgColor, height: '100%' }"
        style="cursor: pointer"
    >
        <div
            fxLayout
            fxLayoutAlign="center"
            style="position: relative; width: 100%; height: 100%"
        >
            <div
                fxFlex="nogrow"
                fxLayout
                fxLayoutAlign="space-between"
                class="content-overlay-box"
                [ngStyle]="{ position: 'absolute', width: '100%' }"
            >
                <img
                    *ngIf="item?.overlay?.image"
                    (click)="process(item?.link)"
                    class="overlayImg"
                    [ngStyle.gt-xs]="{ marginLeft: '16px', marginTop: '16px' }"
                    [ngStyle.xs]="{ marginLeft: '8px', marginTop: '8px' }"
                    src="{{ item?.overlay?.image }}"
                />
                <p
                    fxLayoutAlign="start center"
                    class="new"
                    ngClass.xs="new__mobile"
                    [ngStyle]="{
                        color: item?.overlay?.title?.color,
                        backgroundColor: item?.overlay?.background,
                        zIndex: 1
                    }"
                >
                    {{ item.overlay?.title?.text }}
                </p>
                <button
                    *ngIf="item?.button?.icon"
                    mat-icon-button
                    fxLayoutAlign="center center"
                    style="z-index: 3"
                    (mouseenter)="
                        item?.hoverEnabled
                            ? setHoverImage($event, 'wishlist')
                            : ''
                    "
                    (mouseleave)="
                        item?.hoverEnabled
                            ? setInitialImage($event, 'wishlist')
                            : ''
                    "
                    ngClass.gt-xs="wishlist-desktop-button"
                    (click)="process(item?.button.link)"
                >
                    <img
                        class="icon"
                        src="{{ item?.button?.icon }}"
                        ngClass.xs="icon__mobile"
                        appImageCDN
                    />
                </button>
            </div>
            <picture
                style="padding-top: 100%"
                [ngStyle]="{ backgroundColor: item?.productBgColor }"
                class="content-image"
                (mouseenter)="setHoverImage($event, 'content')"
                (mouseleave)="setInitialImage($event, 'content')"
            >
                <a
                    class="anchor-tag"
                    [routerLink]="[item.link | pageIdFromLink]"
                    [queryParams]="item.link | queryParamFromLink"
                >
                    <img
                        class="image"
                        src="{{ currentVisibleImage }}"
                        appImageCDN
                    />
                </a>
            </picture>
        </div>
    </div>
    <div
        fxLayout="column"
        style="width: 100%; padding: 12px 24px"
        ngStyle.xs="padding-left: 13px; padding-bottom: 14px;background-color: {{
            item?.productBgColor
        }};"
        [ngStyle]="{
            height: item.cta ? '96px' : 'none',
            backgroundColor: item?.productBgColor
        }"
        [ngClass.xs]="{ mar8: !item.cta }"
    >
        <a
            *ngIf="botAgent"
            style="text-decoration: none; color: black"
            [routerLink]="[item.link | pageIdFromLink]"
            [queryParams]="item.link | queryParamFromLink"
        >
            <div class="mrp" fxLayout>
                <p *ngIf="item?.price?.text" class="price" style="margin: 0">{{
                    item.price?.text
                }}</p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p *ngIf="item?.title?.text" class="text">
                {{ item.title?.text }}
            </p>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </a>
        <ng-container *ngIf="!botAgent">
            <p
                class="variant-text-v3"
                ngClass.xs="variant-text-v3__mobile"
                ngStyle.xs="{ fontSize: '12px!important' }"
            >
                {{ item.title?.text }}
            </p>
            <div class="mrp-v2" fxLayout>
                <p
                    class="price_v3"
                    style="margin: 0"
                    [ngStyle.xs]="{ fontSize: '13px' }"
                    >{{ item.price?.text }}</p
                >
                <p
                    [ngStyle.xs]="{
                        fontSize: '13px',
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p
                *ngIf="item?.subtitle?.text"
                [ngStyle.xs]="{ fontSize: '13px' }"
                class="variant-offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </ng-container>
    </div>
    <button
        *ngIf="item.cta"
        color="primary"
        class="call-to-action-button"
        style="height: 36px"
        mat-raised-button
        (click)="process(item?.cta?.link)"
    >
        {{ item.cta?.text }}
    </button>
</div>
<div
    fxLayout="column"
    *ngIf="item?.layout === 'product-without-variant-details-v3'"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
    [ngStyle.xs]="{ marginBottom: '10px' }"
>
    <div
        *ngIf="!!item?.image"
        fxLayout="column"
        [ngStyle]="{ backgroundColor: item?.productBgColor, height: '100%' }"
        style="cursor: pointer"
    >
        <div
            fxLayout
            fxLayoutAlign="center"
            style="padding: 0 0 0; position: relative; width: 100%"
        >
            <div
                fxFlex="nogrow"
                fxLayout
                fxLayoutAlign="space-between"
                class="content-overlay-box"
                [ngStyle]="{ position: 'absolute', width: '100%' }"
            >
                <img
                    *ngIf="item?.overlay?.image"
                    (click)="process(item?.link)"
                    class="overlayImg"
                    [ngStyle.gt-xs]="{ marginLeft: '16px', marginTop: '16px' }"
                    [ngStyle.xs]="{ marginLeft: '8px', marginTop: '8px' }"
                    src="{{ item?.overlay?.image }}"
                />
                <p
                    fxLayoutAlign="start center"
                    class="new"
                    ngClass.xs="new__mobile"
                    [ngStyle]="{
                        color: item?.overlay?.title?.color,
                        backgroundColor: item?.overlay?.background,
                        zIndex: 1
                    }"
                >
                    {{ item.overlay?.title?.text }}
                </p>
                <button
                    *ngIf="item?.button?.icon"
                    mat-icon-button
                    fxLayoutAlign="center center"
                    style="z-index: 3"
                    (mouseenter)="
                        item?.hoverEnabled
                            ? setHoverImage($event, 'wishlist')
                            : ''
                    "
                    (mouseleave)="
                        item?.hoverEnabled
                            ? setInitialImage($event, 'wishlist')
                            : ''
                    "
                    ngClass.gt-xs="wishlist-desktop-button"
                    (click)="process(item?.button.link)"
                >
                    <img
                        class="icon"
                        src="{{ item?.button?.icon }}"
                        ngClass.xs="icon__mobile"
                        appImageCDN
                    />
                </button>
            </div>
            <picture
                ngStyle.xs="padding-top:100%"
                style="width: 100%; padding-top: 78%"
                [ngStyle]="{ backgroundColor: item?.productBgColor }"
                class="content-image"
                (mouseenter)="setHoverImage($event, 'content')"
                (mouseleave)="setInitialImage($event, 'content')"
            >
                <a
                    class="anchor-tag"
                    [routerLink]="[item.link | pageIdFromLink]"
                    [queryParams]="item.link | queryParamFromLink"
                >
                    <img
                        class="image"
                        src="{{ currentVisibleImage }}"
                        appImageCDN
                    />
                </a>
            </picture>
        </div>
    </div>
    <div
        fxLayout="column"
        style="margin-top: -1px; padding-left: 26px; padding-bottom: 34px"
        ngStyle.xs="padding-left: 13px; padding-bottom: 14px;background-color: {{
            item?.productBgColor
        }};"
        [ngStyle]="{
            height: item.cta ? '96px' : 'none',
            backgroundColor: item?.productBgColor
        }"
        [ngClass.xs]="{ mar8: !item.cta }"
    >
        <a
            *ngIf="botAgent"
            style="text-decoration: none; color: black"
            [routerLink]="[item.link | pageIdFromLink]"
            [queryParams]="item.link | queryParamFromLink"
        >
            <div class="mrp" fxLayout>
                <p *ngIf="item?.price?.text" class="price" style="margin: 0">{{
                    item.price?.text
                }}</p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p *ngIf="item?.title?.text" class="text">
                {{ item.title?.text }}
            </p>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </a>
        <ng-container *ngIf="!botAgent">
            <p
                class="variant-text-v3"
                ngClass.xs="variant-text-v3__mobile"
                ngStyle.xs="{ fontSize: '12px!important' }"
            >
                {{ item.title?.text }}
            </p>
            <div class="mrp-v2" fxLayout>
                <p
                    class="price_v3"
                    style="margin: 0"
                    [ngStyle.xs]="{ fontSize: '13px' }"
                    >{{ item.price?.text }}</p
                >
                <p
                    [ngStyle.xs]="{
                        fontSize: '13px',
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p
                *ngIf="item?.subtitle?.text"
                [ngStyle.xs]="{ fontSize: '13px' }"
                class="variant-offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </ng-container>
    </div>
    <button
        *ngIf="item.cta"
        color="primary"
        class="call-to-action-button"
        style="height: 36px"
        mat-raised-button
        (click)="process(item?.cta?.link)"
    >
        {{ item.cta?.text }}
    </button>
</div>
<div
    fxLayout="column"
    *ngIf="item?.layout === 'product-in-grid'"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
    [ngStyle]="{ marginBottom: '10px' }"
>
    <div
        *ngIf="!!item?.image"
        fxLayout="column"
        style="background-color: #f7f7f7; cursor: pointer"
    >
        <div
            fxLayout
            fxLayoutAlign="center"
            style="padding: 0 0 0; position: relative; width: 100%"
        >
            <div
                fxFlex="nogrow"
                fxLayout
                fxLayoutAlign="space-between"
                class="content-overlay-box"
                [ngStyle]="{ position: 'absolute', width: '100%' }"
            >
                <img
                    *ngIf="item?.overlay?.image"
                    (click)="process(item?.link)"
                    class="overlayImg"
                    [ngStyle.gt-xs]="{ marginLeft: '16px', marginTop: '16px' }"
                    [ngStyle.xs]="{ marginLeft: '8px', marginTop: '8px' }"
                    src="{{ item?.overlay?.image }}"
                />
                <p
                    fxLayoutAlign="start center"
                    class="new"
                    ngClass.xs="new__mobile"
                    [ngStyle]="{
                        color: item?.overlay?.title?.color,
                        backgroundColor: item?.overlay?.background,
                        zIndex: 1
                    }"
                >
                    {{ item.overlay?.title?.text }}
                </p>
                <button
                    *ngIf="item?.button?.icon"
                    mat-icon-button
                    fxLayoutAlign="center center"
                    style="z-index: 3"
                    (mouseenter)="
                        item?.hoverEnabled
                            ? setHoverImage($event, 'wishlist')
                            : ''
                    "
                    (mouseleave)="
                        item?.hoverEnabled
                            ? setInitialImage($event, 'wishlist')
                            : ''
                    "
                    ngClass.gt-xs="wishlist-desktop-button"
                    (click)="process(item?.button.link)"
                >
                    <img
                        class="icon"
                        src="{{ item?.button?.icon }}"
                        ngClass.xs="icon__mobile"
                        appImageCDN
                    />
                </button>
            </div>
            <picture
                style="width: 100%; padding-top: calc({{
                    measurement
                }} * 100%);"
                class="content-image"
                (mouseenter)="setHoverImage($event, 'content')"
                (mouseleave)="setInitialImage($event, 'content')"
            >
                <a
                    class="anchor-tag"
                    [routerLink]="[item.link | pageIdFromLink]"
                    [queryParams]="item.link | queryParamFromLink"
                >
                    <img
                        class="image"
                        style="background-color: white"
                        src="{{ currentVisibleImage }}"
                        appImageCDN
                    />
                </a>
            </picture>
        </div>
    </div>
    <div
        fxLayout="column"
        style="margin-top: 0px; margin-left: 26px"
        ngStyle.xs="margin-left: 10px"
        [ngStyle]="{ height: item.cta ? '96px' : 'none' }"
        [ngClass.xs]="{ mar8: !item.cta }"
    >
        <a
            *ngIf="botAgent"
            style="text-decoration: none; color: black"
            [routerLink]="[item.link | pageIdFromLink]"
            [queryParams]="item.link | queryParamFromLink"
        >
            <div class="mrp" fxLayout>
                <p *ngIf="item?.price?.text" class="price" style="margin: 0">{{
                    item.price?.text
                }}</p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p *ngIf="item?.title?.text" class="text">
                {{ item.title?.text }}
            </p>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </a>
        <ng-container *ngIf="!botAgent">
            <p
                class="variant-text-v2"
                ngClass.xs="variant-text-v2__mobile"
                ngStyle.xs="{ fontSize: '14px!important' }"
            >
                {{ item.title?.text }}
            </p>
            <div class="mrp-v2" fxLayout>
                <p
                    class="price_v2"
                    style="margin: 0"
                    [ngStyle.xs]="{ fontSize: '13px' }"
                    >{{ item.price?.text }}</p
                >
                <p
                    [ngStyle.xs]="{
                        fontSize: '13px',
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p
                *ngIf="item?.subtitle?.text"
                [ngStyle.xs]="{ fontSize: '13px' }"
                class="variant-offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </ng-container>
    </div>
    <button
        *ngIf="item.cta"
        color="primary"
        class="call-to-action-button"
        style="height: 36px"
        mat-raised-button
        (click)="process(item?.cta?.link)"
    >
        {{ item.cta?.text }}
    </button>
</div>

<div
    fxLayout="column"
    *ngIf="item?.layout === 'product-without-variant-details-v4'"
    [ngClass]="{
        pad20: item.cta,
        pad50: !item.cta && scrollingType === 'vertical',
        pad0: scrollingType === 'horizontal'
    }"
    [ngStyle.gt-xs]="{ justifyContent: 'space-between', flex: 1 }"
>
    <div
        *ngIf="!!item?.image"
        fxLayout="column"
        style="background-color: #f7f7f7; cursor: pointer"
    >
        <div
            fxLayout
            fxLayoutAlign="center"
            style="padding: 0 0 0; position: relative; width: 100%"
        >
            <div
                fxFlex="nogrow"
                fxLayout
                fxLayoutAlign="space-between"
                class="content-overlay-box"
                [ngStyle]="{ position: 'absolute', width: '100%' }"
            >
                <img
                    *ngIf="item?.overlay?.image"
                    (click)="process(item?.link)"
                    class="overlayImg"
                    [ngStyle.gt-xs]="{ marginLeft: '16px', marginTop: '16px' }"
                    [ngStyle.xs]="{ marginLeft: '8px', marginTop: '8px' }"
                    src="{{ item?.overlay?.image }}"
                />
                <p
                    fxLayoutAlign="start center"
                    class="new"
                    ngClass.xs="new__mobile"
                    [ngStyle]="{
                        color: item?.overlay?.title?.color,
                        backgroundColor: item?.overlay?.background,
                        zIndex: 1
                    }"
                >
                    {{ item.overlay?.title?.text }}
                </p>
                <button
                    *ngIf="item?.button?.icon"
                    mat-icon-button
                    fxLayoutAlign="center center"
                    style="z-index: 3"
                    (mouseenter)="
                        item?.hoverEnabled
                            ? setHoverImage($event, 'wishlist')
                            : ''
                    "
                    (mouseleave)="
                        item?.hoverEnabled
                            ? setInitialImage($event, 'wishlist')
                            : ''
                    "
                    ngClass.gt-xs="wishlist-desktop-button"
                    (click)="process(item?.button.link)"
                >
                    <img
                        class="icon"
                        src="{{ item?.button?.icon }}"
                        ngClass.xs="icon__mobile"
                        appImageCDN
                    />
                </button>
            </div>
            <picture
                style="width: 100%; padding-top: calc({{
                    measurement
                }} * 100%);"
                [ngStyle]="{ backgroundColor: item?.productBgColor }"
                class="content-image"
                (mouseenter)="setHoverImage($event, 'content')"
                (mouseleave)="setInitialImage($event, 'content')"
            >
                <a
                    class="anchor-tag"
                    [routerLink]="[item.link | pageIdFromLink]"
                    [queryParams]="item.link | queryParamFromLink"
                >
                    <img
                        class="image"
                        style="background-color: white"
                        src="{{ currentVisibleImage }}"
                        appImageCDN
                    />
                </a>
            </picture>
        </div>
    </div>
    <div
        fxLayout="column"
        [ngStyle.gt-xs]="{ margin: '0 31px 33px 31px' }"
        [ngStyle.xs]="{ margin: '0 16px 16px 16px' }"
        [ngStyle]="{ height: item.cta ? '96px' : 'none' }"
        [ngClass.xs]="{ mar8: !item.cta }"
    >
        <a
            *ngIf="botAgent"
            style="text-decoration: none; color: black"
            [routerLink]="[item.link | pageIdFromLink]"
            [queryParams]="item.link | queryParamFromLink"
        >
            <div class="mrp" fxLayout>
                <p *ngIf="item?.price?.text" class="price" style="margin: 0">{{
                    item.price?.text
                }}</p>
                <p
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p *ngIf="item?.title?.text" class="text">
                {{ item.title?.text }}
            </p>
            <p
                *ngIf="item?.subtitle?.text"
                class="offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </a>
        <ng-container *ngIf="!botAgent">
            <p
                class="variant-text-v2"
                ngClass.xs="variant-text-v2__mobile"
                ngStyle.xs="{ fontSize: '14px!important' }"
            >
                {{ item.title?.text }}
            </p>
            <div class="mrp-v2" fxLayout>
                <p
                    class="price_v2"
                    style="margin: 0"
                    [ngStyle.xs]="{ fontSize: '13px' }"
                    >{{ item.price?.text }}</p
                >
                <p
                    [ngStyle.xs]="{
                        fontSize: '13px',
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    [ngStyle]="{
                        margin: '0 0 0 10px',
                        color: item?.mrp?.color
                    }"
                    class="strike"
                    *ngIf="item?.mrp?.text"
                >
                    {{ item.mrp?.text }}
                </p>
            </div>
            <p
                *ngIf="item?.subtitle?.text"
                [ngStyle.xs]="{ fontSize: '13px' }"
                class="variant-offer"
                [ngClass]="{ pad20: item.cta }"
                style="color:{{ item.subtitle?.color }}"
            >
                {{ item.subtitle?.text }}
            </p>
        </ng-container>
    </div>
    <button
        *ngIf="item.cta"
        color="primary"
        class="call-to-action-button"
        style="height: 36px"
        mat-raised-button
        (click)="process(item?.cta?.link)"
    >
        {{ item.cta?.text }}
    </button>
</div>
